module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_4.9ccd5715.png";